import { exponentialBackoff, whitelist } from '@fluidx/utilities';

/**
 * The current cache version that is being used to store `EcsResponse` objects in `LocalStorage`
 * Whenever we change the `EcsResponse` interface or we want to change what we store in cache,
 * we should bump this version to clean previous cached `EcsResponse`
 */
export const cacheVersion = 2;

/**
 * Object representing the ECS request retry policy.
 */
export const ecsClientRetryPolicy = {
  maxRetries: 3,
  filter: whitelist([429, 500, 503]),
  backoffFn: exponentialBackoff(500 /* initialRetryIntervalMs */)
};

/**
 * Regex pattern to validate guestAgents from ecsClientConfiguration
 */
export const guestAgentPattern = /.+\S\([^\(\)]+\)$/;
